import { ZSchema } from "../utils/zodSchema";
import { mongoId } from '../utils/basicSchemas/_id.z.schema';
import { z } from "zod";

const options = z
  .object({
    on_push: z.boolean(),
    on_email: z.boolean(),
  })
  .optional();

const NotificationSettingsSchema = z.object({
  collaboration: options,
  comments: options,
  mentioned: options,
  followed: options,
  messages: options,
  gallery: options,
});

const userIdSchema = z.object({
  id: mongoId("transaction id"),
});


const userNotificationSettingsValidator = new ZSchema({
  bodySchema: NotificationSettingsSchema,
});
const userIdValidator = new ZSchema({
  paramSchema: userIdSchema,
});

export { userNotificationSettingsValidator, userIdValidator };
